import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { CreateProgrammeViewModel } from "./CreateProgrammeView_model";
import { SingleForm } from "../../forms/singleFormModel/SingleForm_view";
import I18n from "../../../../core/localization/I18n";
import { Panel } from "../../../../components/ui/Panel";
import { useNavigate } from "react-router-dom";
import { useRefreshClaims } from "../../../../core/auth/authorise";
import { useFlightPathUser } from "../../../../core/auth_insight";
import { useCurrentOrganisationId } from "../../../../services/local/organisationContext/OrganisationContextModel";

export interface CreateProgrammeViewProps {}

const CreateProgrammeView: React.FunctionComponent<CreateProgrammeViewProps> = observer(props => {
  const user = useFlightPathUser();
  const organisationId = useCurrentOrganisationId();
  const refreshClaims = useRefreshClaims();
  const navigate = useNavigate();
  const [model] = useState(() => new CreateProgrammeViewModel(user, refreshClaims, navigate, organisationId));

  useEffect(() => {
    model.onMount();
    return model.onUnmount;
  });

  return (
    <div data-testid="create-programme-view" className="create-programme-view container-fluid pt-8">
      <div className="row mb-4">
        <div className="col-lg-7">
          <h1>
            {I18n.t("phrases.createNew")} {I18n.t("entities.programme")}
          </h1>
          <p>{I18n.t("phrases.createProgrammeDescription")}</p>
        </div>
      </div>
      <div className="col-6">
        <Panel.Panel hasBorderRadius={true} type={Panel.PanelTypes.OUTLINES} className="p-4 mb-4">
          <div className="row">
            <div className="col-12">
              <SingleForm model={model.formModel} />
            </div>
          </div>
        </Panel.Panel>
      </div>
    </div>
  );
});

export { CreateProgrammeView };
